package ai.flowstorm.common.id

data class StringId(override val value: String) : Id